module.exports = "<div class=\"log-box-wrapper\">\n    <div class=\"log-box\">\n        <pre class=\"log-box-text\">{{text}}</pre>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/ui-elements/ui-log-box/ui-log-box.html
// module id = 1123
// module chunks = 3